import { render } from "./DateRangeColumnDisplayItem.vue?vue&type=template&id=6b33806d&ts=true"
import script from "./DateRangeColumnDisplayItem.vue?vue&type=script&lang=ts"
export * from "./DateRangeColumnDisplayItem.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__